<template>
  <div
    class="ViewmedicaBrochureLogo"
    :class="{ textlogo: !image, imagelogo: image }"
    :style="{ color }"
    ref="logo"
    @dragstart.stop.prevent
  ></div>
</template>

<script>
export default {
  props: {
    image: {
      required: true
    }
  },

  data() {
    return {
      span: null
    };
  },

  computed: {
    practice() {
      return this.$store.state.branding.practice;
    },
    color() {
      return this.$store.state.branding.color;
    }
  },

  mounted() {
    console.log("Logo -> mounted");
    if (!this.image) {
      this.renderText();
      this.$nextTick(() => {
        this.fitText();
      });
    } else {
      this.renderImage();
    }
  },

  methods: {
    renderText() {
      this.span = document.createElement("span");
      this.span.innerText = this.practice;
      this.$refs.logo.appendChild(this.span);
    },

    renderImage() {
      this.image.title = `${this.$store.state.branding.practice} Logo`;
      this.$refs.logo.appendChild(this.image.cloneNode(true));
    },

    fitText() {
      let fontsize = 64;
      this.span.style.fontSize = `${fontsize}px`;

      while (this.span.offsetHeight >= 80 && fontsize >= 4) {
        fontsize--;
        this.span.style.fontSize = `${fontsize}px`;
      }
    }
  }
};
</script>

<style lang="scss">
.ViewmedicaBrochureLogo {
  position: absolute;
  top: 10pt;
  left: 24pt;
  width: 270pt;
  height: 60pt;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.ViewmedicaBrochureLogo span {
  font-size: 64px;
  font-weight: bold;
  display: inline-block;
  height: auto;
  width: 100%;
}

.ViewmedicaBrochureLogo img {
  width: auto;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: bottom left;
}
</style>
